<template>
  <div>
    <b-row class="p-3">
      <b-col cols="12">
        <b-tabs v-model="$store.state.employeeDashboardTabIndex">
          <b-tab
            title="ACTIONS REQUIRED"
            :lazy="$store.state.employeeDashboardActionsLazyLoad"
          >
            <b-overlay
              :show="isLoading"
              rounded="sm"
            >
              <b-card
                no-body
                class="shadow-sm pt-0 pl-0 pr-0 m-4 mb-0"
              >
                <b-navbar
                  class="background-white"
                  toggleable="lg"
                >
                  <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                  <b-navbar-brand
                    href="#"
                    class="text-dark"
                  >
                    <strong>Actions Required</strong>
                  </b-navbar-brand>

                  <b-collapse
                    id="nav-collapse"
                    is-nav
                  >
                    <b-navbar-nav class="ml-auto">
                      <b-nav-form>
                        <b-button
                          variant="outline-info"
                          size="sm"
                          class="mr-2"
                          @click="reloadTable"
                        >
                          <font-awesome-icon icon="sync" />
                        </b-button>
                        <b-form-group>
                          <b-input-group size="sm">
                            <b-form-input
                              v-model="filter"
                              type="search"
                              id="filterInput"
                              placeholder="Type to Search"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button
                                :disabled="!filter"
                                @click="filter = ''"
                              >Clear</b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-nav-form>
                    </b-navbar-nav>
                  </b-collapse>
                </b-navbar>
                <b-table
                  class="main-table"
                  hover
                  striped
                  sticky-header="calc(100vh - 395px)"
                  fixed
                  id="users-data-table"
                  :busy.sync="isLoading"
                  :items="getOnboardingTaskData"
                  :fields="staticFields"
                  :filter="filter"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  responsive="sm"
                  selectable
                  select-mode="single"
                  @row-selected="onSelectRow"
                >
                  <template v-slot:cell(created_at)="data">
                    <p>{{ createdAtDate(data.item.created_at) }}</p>
                  </template>
                  <template v-slot:cell(task_title)="data">
                    <p
                      class="link-text"
                      @click="setUserTaskUrl(data.item)"
                    >{{data.item.task_title}}</p>
                  </template>
                  <template v-slot:cell(task_status)="data">
                    <b-badge
                      v-if="data.item.task_status == '0'"
                      variant="info"
                    >Open</b-badge>
                    <b-badge
                      v-if="data.item.task_status == '1'"
                      variant="warning"
                    >In Progress</b-badge>
                    <b-badge
                      v-if="data.item.task_status == '2'"
                      variant="danger"
                    >On hold</b-badge>
                    <b-badge
                      v-if="data.item.task_status == '3'"
                      variant="dark"
                    >Review</b-badge>
                    <b-badge
                      v-if="data.item.task_status == '4'"
                      variant="success"
                    >Complete</b-badge>
                  </template>
                </b-table>
                <template v-slot:footer>
                  <b-row>
                    <b-col cols="2">
                      <b-form-select
                        v-model="perPage"
                        id="perPageSelect"
                        size="sm"
                        :options="pageOptions"
                      ></b-form-select>
                    </b-col>
                    <b-col cols="6">
                      <p class="text-center">
                        Showing Result From
                        <b>{{fromRows}}</b> to
                        <b>{{toRows}}</b>
                      </p>
                    </b-col>
                    <b-col cols="4">
                      <b-pagination
                        class="float-right"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        first-text="First"
                        prev-text="Prev"
                        next-text="Next"
                        last-text="Last"
                        aria-controls="users-data-table"
                      ></b-pagination>
                    </b-col>
                  </b-row>
                </template>
              </b-card>
            </b-overlay>
          </b-tab>
          <!-- <b-tab
            hidden
            title="MY GIFTS"
            :lazy="$store.state.employeeDashboardGiftsLazyLoad"
          >
            <ApprovalsTab :managerDashboard="false" />
          </b-tab>
          <b-tab
            hidden
            title="MY COMPLAINTS"
            :lazy="$store.state.employeeDashboardComplaintsLazyLoad"
          >
            <ComplaintsTab />
          </b-tab> -->
        </b-tabs>
      </b-col>
      <!-- <b-col cols="3">
        <b-card header-tag="header">
          <template v-slot:header>
            <h6 class="text-left">Activity</h6>
          </template>
          <b-card-body
            class="scrollFlow"
            style="height: calc(100vh - 270px); overflow: hidden auto;"
          >
            <ul class="timeline">
              <li>
                <p class="text-muted">16 June, 2020 - 15:49:26</p>
                <p class="text-muted">Onboarding request has been sent to the Third Party.</p>
              </li>
              <li>
                <p class="text-muted">16 June, 2020 - 15:49:26</p>
                <p class="text-muted">Third Party saved by ethiXbase.</p>
              </li>
              <li>
                <p class="text-muted">16 June, 2020 - 15:49:26</p>
                <p class="text-muted">Instant Due Diligence Report generated by ethiXbase.</p>
              </li>
            </ul>
          </b-card-body>
        </b-card>
      </b-col> -->
    </b-row>
  </div>
</template>
<script>
import { HTTP } from "../../../utils/HTTP";
import CountryCodes from "../../../utils/countryCodes.json";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import moment from "moment";
import "moment/locale/es";
import { EventBus } from "@/event-bus.js";
import ApprovalsTab from "../../../components/employeeComponents/employeeDashboardComponents/approvalsTab.vue";
import ComplaintsTab from "../../../components/employeeComponents/employeeDashboardComponents/myComplaintsTab.vue";
export default {
  name: "ThemeTwoDashboard",
  components: {
    ApprovalsTab,
    ComplaintsTab,
  },
  data () {
    return {
      isLoading: false,
      countryOptions: CountryCodes.countries,
      showComplaintModal: false,
      totalRows: 0,
      fromRows: 0,
      toRows: 0,
      filter: null,
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      staticFields: [
        { key: "created_at", label: "Date", sortable: true },
        { key: "task_title", label: "Task Title", sortable: true },
        // { key: "title", label: "Form Title", sortable: true },
        { key: "task_status", label: "Status", sortable: true },
      ],
      form: {
        giftType: null,
        selectedCurrency: null,
        giftAmount: null,
      },
      currencyValue: null,
      dropzoneOptions: {
        url: process.env.VUE_APP_API_URL + "#",
        thumbnailWidth: 150,
        maxFilesize: 25,
        addRemoveLinks: true,
        autoProcessQueue: false,
        headers: {
          Authorization: "Bearer " + localStorage.getItem( "accessToken" ),
        },
      },
      submiting: false,
      responseSuccess: false,
    };
  },
  validations: {},
  mounted () { },
  computed: {
    rows () {
      return this.totalRows;
    },
  },
  methods: {
    showAddComplaintModal () {
      EventBus.$emit( "onShowAddComplaintModal", "" );
    },
    onSelectRow ( data ) {
      if ( data[0].id ) {
        this.setUserTaskUrl( data[0] )
      }
    },
    setUserTaskUrl ( data ) {
      if ( data.form_type == 1 || data.form_type == 8 || data.form_type == 10 ) {
        this.$store.state.userFormSubmitArray = [];
        this.$store.state.getUserFormSubmitArray = [];
        this.$store.state.validFields = true;
        localStorage.removeItem( "taskId" );
        localStorage.removeItem( "activeFormSchema" );
        localStorage.removeItem( "taskFormData" );
        localStorage.removeItem( "activeTaskStatus" );

        localStorage.setItem( "taskId", data.id );
        this.$router.push( "/emplyee-user-form/" + data.id + "/1" );
        // window.location.href = "/emplyee-user-form/" + data.id + "/1";
      } else if ( data.form_type == 3 ) {
        this.$store.state.userFormSubmitArray = [];
        this.$store.state.getUserFormSubmitArray = [];
        this.$store.state.validFields = true;
        localStorage.removeItem( "taskId" );
        localStorage.removeItem( "activeFormSchema" );
        localStorage.removeItem( "taskFormData" );
        localStorage.removeItem( "activeTaskStatus" );

        localStorage.setItem( "taskId", data.id );
        this.$router.push( "/emplyee-training/" + data.id + "/1" );
        // window.location.href = "/emplyee-training/" + data.id + "/1";
      } else if ( data.form_type == 6 ) {
        this.$store.state.userFormSubmitArray = [];
        this.$store.state.getUserFormSubmitArray = [];
        this.$store.state.validFields = true;
        localStorage.removeItem( "taskId" );
        localStorage.removeItem( "activeFormSchema" );
        localStorage.removeItem( "taskFormData" );
        localStorage.removeItem( "activeTaskStatus" );

        localStorage.setItem( "taskId", data.id );
        this.$router.push( "/employee-pdf-training/" + data.id + "/1" );
        // window.location.href = "/employee-pdf-training/" + data.id + "/1";
      } else if ( data.form_type == 4 ) {
        localStorage.setItem( "taskId", data.id );
        this.getTaskForm( data.id );
      }
    },

    async getTaskForm ( taskId ) {
      this.formButtom = true;
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      let result = await HTTP(
        "post",
        "api/v1/onboarding/employee/task/detail",
        {
          task_id: taskId,
          formType: 4,
        },
        {
          Authorization: token,
        },
        null,
        true
      );
      if ( result.data.task ) {
        let form = result.data.task.schema;
        let form_data = JSON.parse( result.data.task.form_data );
        this.$store.state.userFormSubmitArray = form_data;
        localStorage.setItem( "activeFormSchema", form );
        localStorage.setItem( "activeTaskStatus", result.data.task.task_status );
        localStorage.setItem(
          "examAttemptsToDate",
          result.data.task.exam_attempts_count
        );

        this.$router.push( "/emplyee-user-exam/" + taskId + "/1" );
        // window.location.href = "/emplyee-user-exam/" + taskId + "/1";
      }
    },
    createdAtDate ( value ) {
      moment.locale( "en" );
      return moment( value ).format( "DD/MM/YYYY" );
    },
    reloadTable () {
      this.$root.$emit( "bv::refresh::table", "users-data-table" );
    },
    async getOnboardingTaskData () {
      let employeeId = localStorage.getItem( "employeeId" );
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + ( this.sortDesc == true ? "desc" : "asc" ),
        per_page: this.perPage,
        page: this.currentPage,
      };
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      let result = HTTP(
        "post",
        "api/v1/onboarding/employee/active/tasks/table/" + employeeId,
        formData,
        {
          Authorization: token,
        }
      );

      return result
        .then( ( response ) => {
          const items = response.data.data;
          this.isLoading = false;
          this.fromRows = response.data.from;
          this.toRows = response.data.to;
          this.totalRows = response.data.total;
          this.$store.state.employeeDashboardActionsLazyLoad = false;
          return items;
        } )
        .catch( ( error ) => {
          this.isLoading = false;
          return [error];
        } );
    },
  },
};
</script>